import environmentWeb from '@ktag/styleguide/src/javascripts/config/environment-web';

const environmentQV = {
  subscriptionKey: process.env.REACT_APP_API_KEY ?? 'c1b9a607435d4cef9deb8ff77d629cb7',
  processId: 7111,
  lang: 'DE',
  baseURL: process.env.REACT_APP_API ?? 'https://api.f4d.ch/',
};

// if you want to extend/enhance the default config
// with your own rules, you can do so here, by overriding
// the config, by using object.assign such as this:
//
// const environmentQv = {
//   test: {
//     hostname: 'anotherhostname',
//   },
//   production: {
//     analytics: {
//       trackers: [
//         {
//           name: 'customTrackerId',
//           trackerId: 'UA-XXXXXXXX-1',
//         },
//       ],
//     },
//   },
// };

export default Object.assign(environmentWeb, environmentQV);
